const isExpanded = (eventIdToday, currentAccordion) => {
  return currentAccordion === eventIdToday;
};

export default isExpanded;
